import { Actions } from '../actions/questionnaireSections';
import { AxiosError } from 'axios';
import { DeepReadonly } from 'utility-types';
import { IQuestionnaireSection } from '../interfaces/questionnaireSection';

export type State = DeepReadonly<{
  isFetching: boolean;
  questionnaireSections: IQuestionnaireSection[] | null;
  error: AxiosError | Error | null;
}>;

const initialState: State = {
  isFetching: false,
  questionnaireSections: null,
  error: null
};

export function reducer(state: State = initialState, action: Actions): State {
  switch (action.type) {
    case 'FETCH_QUESTIONNAIRE_SECTIONS_REQUEST':
      return {
        ...state,
        isFetching: true
      };
    case 'FETCH_QUESTIONNAIRE_SECTIONS_SUCCESS':
      return {
        isFetching: false,
        questionnaireSections: action.payload,
        error: null
      };
    case 'FETCH_QUESTIONNAIRE_SECTIONS_FAILURE':
      return {
        ...state,
        isFetching: false,
        error: action.error
      };
    default:
      return state;
  }
}
